








































import Vue from 'vue'
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxFilterRow, DxGrouping, DxGroupPanel,
  DxScrolling,
  DxSelection,
  DxSorting, DxStateStoring
} from 'devextreme-vue/data-grid'
import deMessages from "devextreme/localization/messages/de.json"
import frMessages from "devextreme/localization/messages/fr.json"
import itMessages from "devextreme/localization/messages/it.json"
import { loadMessages, locale } from 'devextreme/localization'

interface ComponentData {
  tableHeight: string
  loading: boolean

  linkedList: any[]
  selectedItem: any | null

}

export default Vue.extend({
  name: 'TicketingReporting',

  components: {
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxSelection,
    DxStateStoring
  },

  props: {
    ticketId: Number
  },

  data (): ComponentData {
    return {
      tableHeight: '',
      loading: false,

      linkedList: [],
      selectedItem: null

    }
  },

  watch: {
    ticketId (newVal: number): void {
      if(newVal) {

      }
    }
  },

  computed: {
    currentUserId (): number {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  methods: {
    rowClick(event: any): void {
      this.selectedItem = event.data
    },

    rowDblClick(event: any): void {
      this.selectedItem = event.data
    },

    onSaveButtonClick (): void {

    },

    onResize (): void {
      if(this.$vuetify.breakpoint.mdAndUp) {
        const vh = window.innerHeight
        if(vh > 500) {
          this.tableHeight = `height: calc(${vh}px - 184px)`
        } else {
          this.tableHeight = '300px'
        }
      } else {
        this.tableHeight = '300px'
      }
    }
  },

  created (): void {
    loadMessages(deMessages)
    loadMessages(frMessages)
    loadMessages(itMessages)
    locale(this.selectedLanguageCode)
  },

  mounted (): void {
    this.linkedList = [
      {id: 1, date: '29.01.2024', timeFrom: '10:00', timeTo: '20:00', hours: '10.00', work: 'Entwicklung intern', workNote: 'Testing', employee: 'Eva Cronauer', step: 'zur Abnahme extern', request: 51796, language: 10, detailOPStep: '' },
      {id: 2, date: '10.02.2024', timeFrom: '00:00', timeTo: '01:00', hours: '1.00', work: 'Entwicklung intern', workNote: 'Testing', employee: 'Eva Cronauer', step: 'zur Abnahme extern', request: 51796, language: 10, detailOPStep: '' },
      {id: 3, date: '10.02.2024', timeFrom: '05:00', timeTo: '06:00', hours: '1.00', work: 'Entwicklung intern', workNote: 'Testing', employee: 'Eva Cronauer', step: 'zur Abnahme extern', request: 51796, language: 10, detailOPStep: '' },
      {id: 4, date: '08.03.2024', timeFrom: '09:00', timeTo: '12:00', hours: '3.00', work: 'Entwicklung intern', workNote: 'Testing', employee: 'Eva Cronauer', step: 'zur Abnahme extern', request: 51796, language: 10, detailOPStep: '' },
      {id: 5, date: '09.03.2024', timeFrom: '15:00', timeTo: '18:00', hours: '3.00', work: 'Entwicklung intern', workNote: 'Testing', employee: 'Eva Cronauer', step: 'zur Abnahme extern', request: 51796, language: 10, detailOPStep: '' },
    ]
  }
})
